var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInspector(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 13.5C11.8833 13.5 12.4167 13.2833 12.85 12.85C13.2833 12.4167 13.5 11.8833 13.5 11.25C13.5 10.6167 13.2833 10.0833 12.85 9.65C12.4167 9.21667 11.8833 9 11.25 9C10.6167 9 10.0833 9.21667 9.65 9.65C9.21667 10.0833 9 10.6167 9 11.25C9 11.8833 9.21667 12.4167 9.65 12.85C10.0833 13.2833 10.6167 13.5 11.25 13.5ZM16.075 17.5L13.45 14.875C13.1167 15.0917 12.7627 15.25 12.388 15.35C12.0127 15.45 11.6333 15.5 11.25 15.5C10.0667 15.5 9.06267 15.0873 8.238 14.262C7.41267 13.4373 7 12.4333 7 11.25C7 10.0667 7.41267 9.06267 8.238 8.238C9.06267 7.41267 10.0667 7 11.25 7C12.4333 7 13.4373 7.41267 14.262 8.238C15.0873 9.06267 15.5 10.0667 15.5 11.25C15.5 11.6333 15.446 12.0123 15.338 12.387C15.2293 12.7623 15.0667 13.1167 14.85 13.45L17.5 16.1L16.075 17.5ZM2 22V16H4V20H8V22H2ZM16 22V20H20V16H22V22H16ZM2 8V2H8V4H4V8H2ZM20 8V4H16V2H22V8H20Z",
    fill: "#647B8F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInspector);
export default __webpack_public_path__ + "static/media/inspector.e5e9c00b.svg";
export { ForwardRef as ReactComponent };